import React, { useEffect, useRef, useState } from 'react';
import './activity-logs.styles.scss';
import { format } from 'date-fns';
import { getActivityLogs, getAllUsersFromDb } from '@/utils/getAdminData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const AdminActivityLogs = () => {

    const [ toDisplay, setToDisplay ] = useState(null);
    const [ userList, setUserList ] = useState(null);
    const [ filterData, setFilterData ] = useState({})
    const activityRef = useRef();
    const userListRef = useRef();
    const logListener = useRef();
    const userListener = useRef();

    useEffect(() => {
		loadLogs({});
        getUsers();

        return () => {
            if (logListener.current) logListener.current();
            if (userListener.current) userListener.current();
        }
	}, [])

    function loadLogs(filters) {
        if (logListener.current) logListener.current();
        activityRef.current = {};
        setToDisplay(null);
        getActivityLogs({
            ...filters,
            'callback': logCallback,
            'receiveListener': (unsubscribe) => { logListener.current = unsubscribe; }
        })
    }

    function logCallback(data) {
        activityRef.current = {...activityRef.current, ...{[data.id]: data}}
        setToDisplay(activityRef.current)
    }

    function getUsers() {
        getAllUsersFromDb({
            'callback': usersCallback,
            'receiveListener': (unsubscribe) => { userListener.current = unsubscribe; },
        });
        function usersCallback(newUser) {
            userListRef.current = {...userListRef.current, ...{[newUser.appId]: newUser}}
            setUserList(userListRef.current);
        }
    }

    function saveFilterData(key, value) {
        setFilterData({...filterData, ...{[key]: value}});
    }

    return (
        <div className='activity-logs'>
            <div className='section-title'>
                <span>Activity Logs</span>
            </div>
            <p className='meta'>The most recent 100 entries. Entries are deleted automatically after 90 days.</p>
            <div className="g-space-20"></div>
            <div className="filter-row">
                <div className='field'>
                    <select className='small' onChange={(e) => saveFilterData('appId', e.target.value)}>
                        <option value=''>All users</option>
                        {
                            (userList) &&
                            Object.values(userList).sort((a, b) => (a.name ?? '').toLowerCase() > (b.name ?? '').toLowerCase() ? 1 : -1)
                            .map(user => (
                                <option key={user.appId} value={user.appId}>{user.name ?? user.email}</option>
                            ))
                        }
                    </select>
                </div>
                <div className="field">
                    <select className='small' onChange={(e) => saveFilterData('type', e.target.value)}>
                        <option value=''>All log types</option>
                        <option value='error'>Error</option>
                        <option value='success'>Success</option>
                    </select>
                </div>

                <button className='g-button small-btn primary' onClick={() => loadLogs(filterData)}>Filter Results<FontAwesomeIcon icon={faFilter} /></button>
            </div>
            <div className="g-space-20"></div>
            <table className='g-table logs-table'>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>User</th>
                        <th>Type</th>
                        <th>Function</th>
                        <th>Message</th>
                        <th>Data</th>
                    </tr>
                </thead>
                <tbody>
                {
                    (toDisplay) &&
                    Object.values(toDisplay).sort((a,b) => a.ts < b.ts ? 1 : -1)
                    .map(a => (
                        <tr key={a.id}>
                            <td>{format(new Date(a.ts), 'Pp')}</td>
                            <td>{userList?.[a.user]?.name ?? a.user ?? '-'}</td>
                            <td>{a.type}</td>
                            <td>{a.functName}</td>
                            <td>{a.message}</td>
                            <td>{
                                (a.data && typeof a.data === 'object')
                                ?
                                Object.keys(a.data).map(k => (
                                    <div key={k}>
                                        <span>
                                            <b>{k}: </b>{typeof a.data[k] === 'object' ? JSON.stringify(a.data[k]) : String(a.data[k])}
                                        </span><br />
                                    </div>
                                ))
                                :
                                a.data ?? null}</td>
                        </tr>
                    ))
                }
                </tbody>
            </table>

        </div>
    )
}

export default AdminActivityLogs;
